export default "__VITE_ASSET__BlrpCDs___"